import React, { FormEvent, useRef } from "react"
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
// import { RowContainer, LabelTitle } from "./LabelTitle"

import { Button } from "../ui/button"
import { useStore } from "../../lib/states"
import { useClickAway, useToggle } from "react-use"
// import { Textarea } from "../ui/textarea"
// import { cn } from "../../lib/utils"

import { useHookStore } from "../../hook-store/store"

import { 
  loginPageLink,
  signupPageLink,
} from "../../lib/api";

import { marks } from "../../utils/marks";

const DiffusionOptionPaintButton = () => {
  const [
    settings,
    isProcessing,
    prompt,
    runInpainting,
    // updateSettings,
    // showPrevMask,
    // hidePrevMask,
    curLineGroup,
    lastLineGroup,
  ] = useStore((state) => [
    state.settings,
    state.getIsProcessing(),
    state.settings.prompt,
    state.runInpainting,
    // state.updateSettings,
    // state.showPrevMask,
    // state.hidePrevMask,
    state.editorState.curLineGroup,
    state.editorState.lastLineGroup,
  ])

  const [t] = useTranslation('translation');

  const [hStore, hDispatch] = useHookStore();
  const { 
    serverProcessing,
    ipAdapterImage,
    ipAdapterScale,
    modelName,
    ipAdapterImages,
    isIopaintServerExist,
    inputEta,
   } = (hStore as any).iopaintStore;
  const { 
    showToggleNav, 
    showInpaintSettings,
    isAuth,
   } = (hStore as any).uiStore;
  const { 
    usageBasedPrice,
    usageBasedSubscription,
    usageBasedValidMethod,
    usageBasedConfig,
  } = (hStore as any).stripeData;
  const [showScroll, toggleShowScroll] = useToggle(false)

  const ref = useRef(null)
  useClickAway<MouseEvent>(ref, () => {
    if (ref?.current) {
      const input = ref.current as HTMLTextAreaElement
      input.blur()
    }
  })

  // const handleOnInput = (evt: FormEvent<HTMLTextAreaElement>) => {
  //   evt.preventDefault()
  //   evt.stopPropagation()
  //   const target = evt.target as HTMLTextAreaElement
  //   updateSettings({ prompt: target.value })
  // }

  const handleRepaintClick = () => {
    if (!isProcessing) {

      const priceId = usageBasedPrice ? usageBasedPrice.id : '';
      
      const lsCustomerId = localStorage.getItem('customerId');
      const customerId = lsCustomerId ? lsCustomerId : '';

      runInpainting(
        ipAdapterImage,
        ipAdapterScale,
        modelName,
        ipAdapterImages,
        inputEta,
        priceId,
        customerId,
      )
    }

    (hDispatch as any)('SET_SHOWINPAINTSETTINGS', false);
  }

  // const onKeyUp = (e: React.KeyboardEvent) => {
  //   if (e.key === "Enter" && e.ctrlKey && prompt.length !== 0) {
  //     handleRepaintClick()
  //   }
  // }

  // const onMouseEnter = () => {
  //   showPrevMask()
  // }

  // const onMouseLeave = () => {
  //   hidePrevMask()
  // }

  // console.log('lineGroup', lastLineGroup, curLineGroup);
  let isMaskExist = false;

  if (lastLineGroup.length > 0 || curLineGroup.length > 0) {
    isMaskExist = true;
  }



  let isRunbuttonDisabled = false;

  if (isProcessing || serverProcessing || showToggleNav || 
        showInpaintSettings || !prompt || !isIopaintServerExist ||
        !isMaskExist
  ) {
    isRunbuttonDisabled = true; 
  }



  let isUsageBased = false;
  let isUsageBasedOk = true;
  let ubbUnit = 0;

  const aSteps = Math.floor(
                    Number( (settings.sdStrength*settings.sdSteps).toFixed(2) ) 
                  )

  if (settings.seed !== 0 || aSteps > 3) {
    isUsageBased = true;

    if (usageBasedPrice && usageBasedConfig) {
      ubbUnit = usageBasedConfig.bkInpaintUnit;
    }
  }

  if (isUsageBased && (
      !isAuth || !usageBasedSubscription || !usageBasedValidMethod)
  ) {
    isUsageBasedOk = false;
    isRunbuttonDisabled = true;
  }

  return (
      <div 
      // className="flex flex-col gap-1"
      >
        {/* <div>seed: {settings.seed}, a-steps: {aSteps}</div>
        {isUsageBased && <div>is-usage-based</div>}
        {isRunbuttonDisabled && <div>is-runbutton-disabled</div>} */}
        {isUsageBased && (
          <div className='voiceGenerator2Section'>
            {t('diffusionOptions35', 'Because image generation uses a lot of resources, in some input condition, payment is required.')}
            (a-steps {">"} 3, or Seed is not 0)
          </div>
        )}

        {ubbUnit > 0 && (
          <div className='voiceGenerator2Section'>
            Unit{' '}
            <strong>
              {ubbUnit}
              {' '}
              ({Number(usageBasedPrice.unit_amount_decimal)/100*usageBasedConfig.bkInpaintUnit} USD)
            </strong>
          </div>
        )}

        {isUsageBased && !isAuth && (
          <div>
            <div className='voiceGenerator2Section'>
              <strong>
                {t('diffusionOptions36', 'user need to enable usage based billing after login.')}
              </strong>
            </div>
            <div className='voiceGenerator2Section'>
              <a href={loginPageLink}>
                <button className="btnBase">
                  {marks.signInMrak} {t('aboutAuth06', 'Login')}
                </button>
              </a>
              <span> or </span>
              <a href={signupPageLink}>
                <button className="btnBase">
                  {marks.userPlusMrak} {t('aboutAuth07', 'Signup')}
                </button>
              </a>
            </div>
          </div>
        )}

        {isUsageBased && isAuth && !usageBasedSubscription && (
          <div className='voiceGenerator2Section'>
            <div>
              <strong>
                {t('diffusionOptions37', 'Enabling usage based billing is required.')}
              </strong>
            </div>
            <Link
              to="/usage-based-billing"
            >
              <button className='btnBase'>
                {t('diffusionOptions38', 'Go to usage based billing page')}
              </button>
            </Link>
          </div>
        )}

        {isUsageBased && isAuth && usageBasedSubscription && !usageBasedValidMethod && (
          <div className='voiceGenerator2Section'>
            <div>
              <strong>
                {t('diffusionOptions39', 'Card information for payment is required.')}
              </strong>
            </div>
            <Link
              to="/usage-based-billing"
            >
              <button className='btnBase'>
                {t('diffusionOptions38', 'Go to usage based billing page')}
              </button>
            </Link>
          </div>
        )}

        <div className="flex justify-between items-center pr-2">
          <div></div>
          <Button
            // size="sm"
            onClick={handleRepaintClick}
            // disabled={isProcessing || serverProcessing || showToggleNav || 
            //   showInpaintSettings || !prompt || !isIopaintServerExist ||
            //   !isMaskExist
            //   // || curLineGroup.length === 0
            // }
            disabled={isRunbuttonDisabled}
            // onMouseEnter={onMouseEnter}
            // onMouseLeave={onMouseLeave}
          >
            {!(serverProcessing || isProcessing) && (
              <span>Paint</span>
            )}
            {(serverProcessing || isProcessing) && (
              <span>busy...</span>
            )}
          </Button>
        </div>
      </div>
  )
}

export default DiffusionOptionPaintButton
